import type { AccommodationListingDTO } from '@shared/types/Accommodations.types';

/**
 * Joy-side OTA rate to attach to hotel click events.
 *
 * On a direct-booking listing the tile blanks `pricingInfo` so it cannot quote our ZH/Nuitee
 * rate as the brand's. The same figure lives on `otaTransferredPricing` for telemetry. That is
 * every brand-owned hotel, not only the ones that won a paid ad slot (`isSponsored`). OTA
 * listings still have the displayed rate on `pricingInfo.values`.
 *
 * This is never Marriott's public rate.
 */
export const otaTransferredPricingTelemetry = (listing: AccommodationListingDTO) => {
  if (listing.type !== 'standardHotel') {
    return {};
  }

  const transferred = listing.otaTransferredPricing;
  if (transferred) {
    return {
      otaNightlyBaseRate: transferred.nightlyBaseRate,
      otaTotalRate: transferred.totalRate,
      otaCurrency: transferred.currency,
      otaPriceSource: transferred.source,
    };
  }

  const displayed = listing.pricingInfo.values;
  if (displayed) {
    return {
      otaNightlyBaseRate: displayed.nightlyBaseRate,
      otaTotalRate: displayed.totalRate,
      otaCurrency: displayed.totalRateCurrency,
      otaPriceSource: listing.pricingInfo.source,
    };
  }

  return {};
};
